import { render } from "./Orchestra.vue?vue&type=template&id=12bffb06"
import script from "./Orchestra.vue?vue&type=script&lang=js"
export * from "./Orchestra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__